import * as React from 'react';
export const azupaySvg = React.forwardRef(function azupaySvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M4.434 13.49c-.063-.18-.245-.144-.372-.18C1.812 12.62.224 10.777.024 8.6-.185 6.286.977 4.153 3.02 3.119c2.078-1.053 4.455-.762 6.243.87 1.297 1.18 2.513 2.47 3.775 3.694.871.853 1.76 1.697 2.64 2.541l-1.814 1.815c-.481-.517-.953-1.053-1.452-1.552-1.534-1.524-3.05-3.067-4.628-4.555-1.443-1.361-3.24-1.325-4.51.009C2.229 7.03 2.166 8.7 3.1 9.906a3.056 3.056 0 0 0 3.866.808c.717-.381 1.198-1.007 1.751-1.57.127-.127.245-.272.336-.363l1.67 1.697c-1.044 1.452-2.468 2.605-4.41 3.022-.626-.01-1.253-.01-1.879-.01Zm9.619-9.573 1.461 1.489c-.526.526-1.08 1.07-1.633 1.624-.445-.472-.971-1.026-1.47-1.552.49-.463 1.052-.998 1.642-1.56Z',
    }),
  );
});
azupaySvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var azupay = {
  category: 'paymentmethod',
  colorable: true,
  name: 'azupay',
  svg: azupaySvg,
};
